module.exports = __webpack_public_path__ + "static/pwit.f2c2078e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/pwit.svg
// module id = 730
// module chunks = 213534597649335